<template>
  <div class="d-inline-block">
    <v-btn-toggle v-if="!chips && !dense">
      <template v-for="type in testTypes">
        <v-tooltip :key="type.uuid" color="grey darken-3" bottom>
          <template v-slot:activator="{on}">
            <v-btn v-on="on"
                   :color="CommonFunctions.sampleRequiredTestColor(sample.required_tests, type)"
                   :disabled="retest_only ? !sample.sample_tests.some(test => test.sample_test_type_uuid === type.uuid && test.retest) : !sample.required_tests.some(test => test.sample_test_type_uuid === type.uuid)"
                   :value="type.uuid"
                   v-bind="btn_attributes"
            >{{type.name}}{{show_count ? `(${CommonFunctions.testCount(sample.sample_tests, type.uuid, retest_only).toString()})` : '' }}</v-btn>
          </template>
          <span>{{type.description}}</span>
        </v-tooltip>
      </template>
    </v-btn-toggle>
    <template v-else-if="chips" v-for="type in testTypes">
      <v-tooltip :key="type.uuid" color="grey darken-4" bottom>
        <template v-slot:activator="{on}">
          <v-chip
              v-on="on"
              :color="CommonFunctions.sampleRequiredTestColor(sample.required_tests, type)"
              :key="type.uuid"
              :value="type.uuid"
              v-bind="btn_attributes"
              class="pa-1"
              label>
            {{type.name}} <span v-if="show_count">-{{CommonFunctions.testCount(sample.required_tests, type.uuid, retest_only).toString()}}</span>
          </v-chip>
        </template>
        <span>{{type.description}} - {{ CommonFunctions.sampleTestStatus(sample.required_tests, type) }}</span>
      </v-tooltip>
    </template>
    <template v-else-if="dense" v-for="(type, index) in testTypes">
      <v-tooltip :key="type.uuid" color="grey darken-4" bottom>
        <template v-slot:activator="{on}">
          <v-btn
              v-on="on"
              :class="CommonFunctions.sampleRequiredTestColor(sample.required_tests, type)"
              :value="type.uuid"
              v-bind="btn_attributes"
              x-small
              tile
              icon
              depressed
          >
            {{type.name}}{{show_count ? `(${CommonFunctions.testCount(sample.required_tests, type.uuid, retest_only).toString()})` : '' }}
          </v-btn>
        </template>
        <span>{{type.description}} {{ index + 1 }}</span>
      </v-tooltip>
    </template>
  </div>
</template>

<script>
import CommonFunctions from "@/Lib/CommonFunctions";
export default {
  name: "RequiredTests",
  components: {},
  data: () => ({
    CommonFunctions
  }),
  props:{
    sample: {
      required: true,
    },
    chips:{
      required: false,
      default: false,
      type: Boolean
    },
    dense:{
      required: false,
      default: false,
      type: Boolean
    },
    btn_attributes:{
      required: false,
      default: () => ({
        small: true,
      })
    },
    show_count: {
      required: false,
      type: Boolean,
      default: false
    },
    retest_only: {
      required: false,
      type: Boolean,
      default: false,
    }
  },
  computed:{
    testTypes(){
      return this.$store.$db().model('sampleTestTypes').all();
    },
  },
}
</script>

<style scoped>

</style>
